import {Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter} from '@angular/core';
import {FidjiDocumentActionNatifService, IMDocument} from '@immanens-com/fidji-api-module';
import {Observable} from 'rxjs/Observable';
import {UserControllerService} from '../../../core/services/user/user-controller.service';
import {DocumentControllerService} from '../../../core/services/document/document-controller.service';



@Component({
  selector: 'app-documents-grid',
  templateUrl: './documents-grid.component.html',
  styleUrls: ['./documents-grid.component.scss'],
  encapsulation : ViewEncapsulation.None // otherwise it seems we have conflicts with bootstrap
})
export class DocumentsGridComponent {

  @Input() active = true;
  @Input() documentList: IMDocument[];
  @Input() canDeleteDocuments = false;

  @Input() userDocumentList: IMDocument[]; // list of documents to display

  @Output() clickCoverDocument = new EventEmitter();
  @Output() clickButtonDocument = new EventEmitter();

  public emitSelectedDocument(document: IMDocument) {
    this.clickCoverDocument.next(document);
  }

  public emitButtonDocument(document: IMDocument) {
    this.clickButtonDocument.next(document);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/documents-list/documents-grid/documents-grid.component.ts